import type { OgpData, OgpMetadata } from "@/shared/types/ogp";

const METADATA_FIELDS: readonly (keyof OgpMetadata)[] = [
  "title",
  "description",
  "image",
  "imageUrl",
  "imageWidth",
  "imageHeight",
  "url",
  "type",
  "siteName",
  "favicon",
];

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function httpUrl(value: string, base?: string): string {
  const url = new URL(value, base);
  if (url.protocol !== "https:" && url.protocol !== "http:") {
    throw new Error("Invalid OGP URL protocol");
  }
  return url.href;
}

/** プロキシ応答を検証し、表示に使うフィールドだけを返す。 */
export function parseOgpData(value: unknown): OgpData {
  if (
    !isRecord(value) ||
    typeof value.url !== "string" ||
    typeof value.cached !== "boolean" ||
    !isRecord(value.data)
  ) {
    throw new Error("Invalid OGP response");
  }
  const url = httpUrl(value.url);
  const data: OgpMetadata = {};
  for (const field of METADATA_FIELDS) {
    const fieldValue = value.data[field];
    if (fieldValue === undefined) continue;
    if (typeof fieldValue !== "string") throw new Error("Invalid OGP metadata");
    data[field] = fieldValue;
  }
  for (const field of ["image", "imageUrl", "url", "favicon"] as const) {
    const fieldValue = data[field];
    if (fieldValue) data[field] = httpUrl(fieldValue, url);
  }
  return { url, data, cached: value.cached };
}
